import { BulkActionsBarOutlet, BulkActionsBarProvider } from '@calendly/ui/components/bulk-actions-bar';
import { PageHeaderContext, PageHeaderOutlet } from '@calendly/ui/components/page-header';
import { MainContainerSizeProvider } from '@calendly/ui/hooks/main-container-size-context';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { StickyFooterContext, StickyFooterOutlet } from 'features/layout';
import { SeatRequestsBanner } from 'features/seat_requests';
import { CenterPanelContent } from './CenterPanelContent';
import { CenterPanelLayoutProvider } from './centerPanelLayoutContext';
import { PageFilterContext, PageFilterGradient, PageFilterOutlet } from './pageFilterContext';
const centerPanelContainerCss = "ci8rqzu";
const topChromeCss = "t1lwhhm2";
const bottomChromeCss = "bfnhjpz";
interface CenterPanelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Primary content column in the app shell body row.
 * Owns the page header, filter bar, scrollable content region (`CenterPanelContent`), sticky footer, and bulk-actions bar.
 * Also provides layout context (`CenterPanelLayoutProvider`) so child routes can opt into wide mode.
 *
 * @param children - Page content rendered inside the scrollable region.
 * @param className - Additional class applied to the outer container (e.g. shared `bodyPanelCss` border-radius).
 */
export const CenterPanel = ({
  children,
  className
}: CenterPanelProps) => <CenterPanelLayoutProvider>
    <MainContainerSizeProvider>
      {sizeRef => <PageHeaderContext>
          <PageFilterContext>
            <BulkActionsBarProvider>
              <StickyFooterContext>
                <main ref={sizeRef} className={classNames(className, centerPanelContainerCss)} data-component="main" id="shell-content">
                  <div className={topChromeCss} id="shell-content-header">
                    <SeatRequestsBanner />
                    <PageHeaderOutlet />
                    <PageFilterOutlet />
                  </div>
                  <PageFilterGradient />
                  <CenterPanelContent>
                    {children}
                  </CenterPanelContent>
                  <div className={bottomChromeCss}>
                    <StickyFooterOutlet />
                    <BulkActionsBarOutlet />
                  </div>
                </main>
              </StickyFooterContext>
            </BulkActionsBarProvider>
          </PageFilterContext>
        </PageHeaderContext>}
    </MainContainerSizeProvider>
  </CenterPanelLayoutProvider>;

require("./CenterPanel.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanel.tsx");